import { Association, Group } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { GroupAssociationEntityConfig } from "./config";
import { GroupUserFilters as GroupAssociationFilters } from "./filters";
import { GroupUserMethods as GroupAssociationMethods } from "./methods";

@HyperEntity("group-association", GroupAssociationEntityConfig)
export class GroupAssociation extends extender(
  GroupAssociationFilters,
  GroupAssociationMethods,
) {
  @Fields.string({
    dbName: "group_id",
  })
  groupId = "";

  @Fields.string({
    dbName: "association_id",
  })
  associationId = "";

  @Relations.toOne<GroupAssociation, Group>(() => Group, "groupId")
  group?: Group;

  @Relations.toOne<GroupAssociation, Association>(
    () => Association,
    "associationId",
  )
  association?: Association;

  @Fields.boolean({ dbName: "is_leader", defaultValue: () => false })
  isLeader = false;

  @Fields.createdAt({
    dbName: "created_at",
  })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
